import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Mail, Send } from "lucide-react";

const EMAIL_PREFERENCE_OPTIONS = [
  { id: "billing_reminders", label: "Billing Reminders", description: "Get notified before subscription renewals (15 & 7 days)" },
  { id: "payment_alerts", label: "Payment Alerts", description: "Receive emails for successful and failed payments" },
  { id: "student_activity", label: "Student Activity", description: "Get notified when students are enrolled or bulk uploaded" },
  { id: "admin_activity", label: "Admin Activity", description: "Receive alerts when administrators are added or modified" },
  { id: "weekly_digest", label: "Weekly Digest", description: "Weekly summary of school activity and analytics" },
];

export function EmailPreferencesTab({
  admin,
  emailPreferences,
  savingEmailPrefs,
  sendingTestEmail,
  onUpdatePreference,
  onSendTestEmail
}) {
  return (
    <div className="space-y-6">
      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Mail className="w-5 h-5 text-emerald-600" />
            Email Notification Preferences
          </CardTitle>
          <CardDescription>
            Choose which notifications you want to receive via email at {admin?.email}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {EMAIL_PREFERENCE_OPTIONS.map(pref => (
            <div 
              key={pref.id} 
              className="flex items-center justify-between p-4 rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors"
            >
              <div className="flex-1">
                <p className="font-medium text-slate-800">{pref.label}</p>
                <p className="text-sm text-slate-500">{pref.description}</p>
              </div>
              <Switch
                checked={emailPreferences[pref.id] || false}
                onCheckedChange={(checked) => onUpdatePreference(pref.id, checked)}
                disabled={savingEmailPrefs}
              />
            </div>
          ))}
        </CardContent>
      </Card>

      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Send className="w-5 h-5 text-emerald-600" />
            Test Email
          </CardTitle>
          <CardDescription>
            Send a test email to verify your email notifications are working
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-4">
            <Button 
              variant="outline"
              onClick={onSendTestEmail}
              disabled={sendingTestEmail}
              data-testid="send-test-email-btn"
            >
              {sendingTestEmail ? (
                <>
                  <div className="w-4 h-4 border-2 border-emerald-200 border-t-emerald-600 rounded-full animate-spin mr-2"></div>
                  Sending...
                </>
              ) : (
                <>
                  <Send className="w-4 h-4 mr-2" />
                  Send Test Email
                </>
              )}
            </Button>
            <span className="text-sm text-slate-500">
              Test email will be sent to <strong>{admin?.email}</strong>
            </span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
